import { reactive } from 'vue';

import { SporopayKeyAccountI } from '@/support/interfaces';

type StateType = {
  sporopayKeyAccounts: SporopayKeyAccountI[];
  sporopayKeyConfirmModal: {
    confirmed: boolean;
    sporopayKey: string;
    sporopayKeyAccount: string;
  };
};

const state = reactive<StateType>({
  sporopayKeyAccounts: [],
  sporopayKeyConfirmModal: {
    confirmed: false,
    sporopayKey: '',
    sporopayKeyAccount: '',
  },
});

export default state;
